var PeopleMedia = PeopleMedia || {};
PeopleMedia.Unsubscribe = (function ($jq) {
    "use strict";
    var Oid = "PeopleMedia.Unsubscribe";

    var submitForm = function(e) {
        try {
            e.stopPropagation();
            e.preventDefault();
            $jq('#frmUnsub').trigger("submit");
        } catch (ex) {
            PeopleMedia.Logger.LogExceptionWithDetail(ex, { Oid: Oid, method: "submitForm" });
        }
    };

    var submitOnEnter = function (e) {
        try {
            var key = e.charCode ? e.charCode : e.keyCode;
            if (key === 13) {
                submitForm(e);
            }
        } catch (ex) {
            PeopleMedia.Logger.LogExceptionWithDetail(ex, { Oid: Oid, method: "submitOnEnter" });
        }
    };

    var initialize = function() {
        try {
            
            $jq('#frmUnsub input').on("keypress", submitOnEnter);
            $jq("#btnUnsubscribe").on("click", submitForm);
        } catch (ex) {
            PeopleMedia.Logger.LogExceptionWithDetail(ex, { Oid: Oid, method: "initialize" });
        }
    };

    return {
        initialize: initialize
    };
})(jQuery);
